module.exports = __webpack_public_path__ + "static/balancetransfer-eb6e415e89345254be1e7ac59d0aaf10.jpg";